var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.872,
    height: 44.425,
    viewBox: "0 0 38.872 44.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M6.941,16.659V12.494a12.494,12.494,0,1,1,24.989,0v4.165h1.388a5.558,5.558,0,0,1,5.553,5.553V38.872a5.558,5.558,0,0,1-5.553,5.553H5.553A5.555,5.555,0,0,1,0,38.872V22.212a5.555,5.555,0,0,1,5.553-5.553Zm5.553,0H26.377V12.494a6.941,6.941,0,1,0-13.883,0Z",
    fill: "#d1002a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockActive);
export default __webpack_public_path__ + "static/media/Lock-active.086f81c93f5a29e85ffe22eea0acbd15.svg";
export { ForwardRef as ReactComponent };